import { setSearch } from '../State/search'

export default (value) => (dispatch) => {
  
  dispatch(setSearch(value))

}
